import {
  Component, EventEmitter,
  Inject,
  Input,
  OnChanges, OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { StorageService } from '@cybfed/core/services/storage.service';
import { TopupService } from '@cybfed/core/services/topup.service';
import { PopupHelperService } from '@cybfed/core/services/popup-helper.service';
import { environment } from '@shared-environments/environment';
import { ModalComponent } from '../modal/modal.component';
import { PackageService } from '@cybfed/core/services/package.service';
import { EventManagerService } from '@cybfed/core/services/event-manager.service';
import { StripeCardComponent } from 'ngx-stripe';
import {DOCUMENT, isPlatformBrowser, NgClass, NgIf} from '@angular/common';
import { WindowRef } from '@cybfed/core/helpers/windowRef.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {ModalService} from "@cybfed/ui-lib/modal/modal.service";
import {
  WhiteLabelCopyFormComponent
} from "@white-label/pages/admin-mode/white-label-template/white-label-copy-form/white-label-copy-form.component";
import {
  PaymentModalComponent
} from "@cybfed/shared/components/topup-component-new/payment-modal/payment-modal.component";
import {DomSanitizer} from "@angular/platform-browser";
import {Subscription, take} from "rxjs";

declare var Stripe: any;

@Component({
  selector: 'app-topup-new-component',
  templateUrl: './topup-component-new.component.html',
  styleUrls: ['./topup-component-new.component.scss'],
  imports: [
    ModalComponent,
    TranslateModule,
    NgIf,
    NgClass
  ],
  standalone: true
})
export class TopupComponentNewComponent implements OnInit, OnChanges, OnDestroy {
  @Input() publisherId: any = null;
  @Input() show: boolean = false;
  @Input() selectedData: any;
  @Input() selectedPayment: any;
  @Input() withoutPackage: boolean = false;
  @Input() withoutUser: boolean = false;
  @Input() hideIdram: boolean = false;
  @Input() hideQiwi: boolean = false;
  @Input() hideStripe: boolean = false;

  @Output() hideModalCallback: EventEmitter<any> = new EventEmitter();
  @Output() changePaymentMethode: EventEmitter<any> = new EventEmitter();
  @Output() startPaymentLoading: EventEmitter<any> = new EventEmitter();
  @Output() endPaymentLoading: EventEmitter<any> = new EventEmitter();
  @Output() finishPayment: EventEmitter<any> = new EventEmitter();

  @ViewChild('modal') modal: any;
  @ViewChild('stripeModal') stripeModal: any;
  @ViewChild(StripeCardComponent) card: any;

  modalOptions: any;
  load: boolean = false;
  stripe: any;
  cardElement: any;
  private topupData: any;
  private ticketPrice: any;

  constructor(private topupService: TopupService,
              @Inject(DOCUMENT) private dom,
              private popupHelperService: PopupHelperService,
              private eventManager: EventManagerService,
              private packageService: PackageService,
              @Inject(PLATFORM_ID) private platformId: any,
              private windowRef: WindowRef,
              private translateService: TranslateService,
              private modalService: ModalService,
              private sanitizer: DomSanitizer

  ) {
  }

  queryParams: any = {
    cybfedId: null,
    topupid: null,
    hideHerder: true,
    displayWidth: 500,
    redirectUrl: environment.portalUrl,
    couponCode: null,
    closeTab: true,
    'returnParams[]': ['couponCode', 'closeTab', 'topupid'],
  };
  protected user: any
  public packages: any;

  private eventSubscriptions: Subscription[] = []; // Store the subscription

  ngOnInit(): void {
    this.ticketPrice = StorageService.getItem(StorageService.statics.ticketPrice);
    this.user =  StorageService.getJsonItem(StorageService.statics.currentUser);
    this.selectedPayment = 'paymentGateway';
    this.modalOptions = {
      size: 'lg',
      centered: true,
      scrollable: true,
      modalDialogClass: 'user-images',
      backdropClass: '',
      backdrop: 'static',
    };
    this.invokeStripe();
    this.loadStripe()
    this.eventSubscriptions.push(this.eventManager.makePaymentTopupNewComponent
        .pipe(take(1))  // This ensures the subscription is triggered only once
        .subscribe((data: any) => {
          this.createOrder(data.paymentMethod);
        }))

  }

  createOrder(method: string) {
    if (!this.selectedData) {
      return;
    }
    if (method === 'idram') {
      return this.buyInQiwi(this.selectedData);
    } else if (method === 'qiwi') {
      return this.buyInQiwi(this.selectedData);
    } else if (method === 'stripe') {
      let amountFromUserCurrency
      if(this.selectedData.topic === 'ticket'){
        amountFromUserCurrency = (200 / 10 * this.ticketPrice).toFixed(2)
      }else {
        amountFromUserCurrency = this.selectedData.amount
      }

      // this.openPopUpQuestion(this.buyInStripe, this.selectedData, amountFromUserCurrency ,this.user.currency);
      return this.buyInStripe(this.selectedData);
    } else if (method === 'paymentGateway') {
      return this.buyInPaymentGateway(this.selectedData);
    }

  }

  openPopUpQuestion(func: any, param = '', amount: any, curr: any) {
    const popupSettings = {
      customClass: {
        container: 'z-index-9999',
        popup: 'bg-000 w-15',
        confirmButton: 'pink-button-imp',
        htmlContainer: 'color-white',
      },
      icon: 'question',
      text: this.translateService.instant('case_of_card').replace('{{amount}}', amount).replace('{{currency}}', curr),
      confirmButtonText: this.translateService.instant('yes'),
    };
    this.popupHelperService.printQuestion(popupSettings, param, func, this);
  }


  buyInCouponMaster(packageData: any) {
    if (this.load) {
      return;
    }
    this.load = true;
    //this.openPaymentModal();
    //TODO: alternative payment with tickets
    // this.selectedDataParams = amount
    // this.selectedDataCurrency = currency
    // this.selectedDataTicketsCount = ticketsCount

    this.eventManager.taskManagementModalEmitter.emit({ event: 'close' });
    let user = StorageService.getJsonItem(StorageService.statics.currentUser);
    //this.queryParams.nickname = user.nickname;
    //this.queryParams.email = user.email;
    this.queryParams.cybfedId = user.userId;
    let topupData;
    if (!this.withoutPackage) {
      topupData = {
        packageId: packageData._id,
        provider: 'couponMaster',
        publisherId: this.publisherId,
        topic: 'ticket',
      };
    } else {
      topupData = {};
    }


    this.topupService.add(topupData).subscribe((data: any) => {
      if (!data.hasError) {

        if (isPlatformBrowser(this.platformId)) {
          this.queryParams.couponCode = data.data.topup.couponCode;
          this.queryParams.topupid = data.data.topup._id;
          let token = btoa(JSON.stringify(this.queryParams));
          let redirectUrl = environment.myBuyDetailUrl + packageData.myByCouponId;
          redirectUrl = redirectUrl + '?token=' + token;
          let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
          if (!isSafari) {

            this.windowRef.nativeWindow.open(redirectUrl, 'targetWindow',
              `toolbar=no,
                      location=no,
                      status=no,
                      menubar=no,
                      scrollbars=yes,
                      resizable=no,
                      width=500,
                      height=615`);
          } else {
            this.windowRef.nativeWindow.location.href = redirectUrl;
          }
          this.load = false;
        }
      } else {
        this.load = false;
        this.popupHelperService.printError({ text: data.errorMessages[0].msg });
      }
    });
  }


  openPaymentModal() {
    this.modal.show();
  }


  buyInQiwi(packageData: any) {
    this.load = true;
    this.startPaymentLoading.emit()
    let topupData;
    if (!this.withoutPackage) {
      topupData = {
        packageId: packageData._id,
        provider: 'qiwi',
        publisherId: this.publisherId,
        topic: 'ticket',
      };
    } else {
      topupData = {
        serviceId: packageData._id,
        provider: 'qiwi',
        topic: 'ticket',
      };
    }

    this.topupService.add(topupData).subscribe((data: any) => {
      if (!data.hasError && isPlatformBrowser(this.platformId)) {

        let redirectUrl = data.data.topup.paymentLink;
        if (redirectUrl) {
          let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
          if (!isSafari) {
            this.windowRef.nativeWindow.open(redirectUrl, '_blank');
          } else {
            this.windowRef.nativeWindow.location.href = redirectUrl;
          }
        } else {
          this.popupHelperService.printError({ text: 'invalidPaymentLink' });
        }
      } else {
        this.popupHelperService.printError({ text: data.errorMessages[0].msg });
      }
      this.load = false;
      this.endPaymentLoading.emit()
    });
  }
  loadStripe() {
    return new Promise((resolve, reject) => {
      if ((<any>window).StripeCheckout) {
        resolve(true); // Already loaded
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://checkout.stripe.com/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => reject('Stripe Checkout script failed to load.');
      document.head.appendChild(script);
    });
  }

  buyInStripe(packageData: any) {
    this.load = true;
    this.startPaymentLoading.emit()
    if (!this.withoutPackage) {
      this.topupData = {
        packageId: packageData._id,
        provider: 'stripe',
        publisherId: this.publisherId,
        topic: this.selectedData.topic,
      };
      let newAmount
      if(this.selectedData.topic === 'ticket'){
        newAmount = this.getAmount(this.selectedData.ticket);
      }else {
        newAmount = this.selectedData.amount
      }

      this.selectedData.description = newAmount.toFixed(2) + ' ' + this.selectedData.currency;
    } else {
      this.topupData = {
        serviceId: packageData._id,
        provider: 'stripe',
        topic: this.selectedData.topic,
        serviceCount: this.selectedData.serviceCount,
        requiredFields: packageData.requiredFields,
        email: packageData.email,
        metadata: packageData.metadata,
        currency: packageData.currency,
      };
      let newAmount
      if(this.selectedData.topic === 'ticket'){
        newAmount =  (this.selectedData.amount * this.ticketPrice + (200 / 10 * this.ticketPrice))
      }else {
        newAmount = this.selectedData.amount
      }
      this.selectedData.description = newAmount.toFixed(2)  + ' ' + this.selectedData.currency;
    }


    this.makePayment();
  }

  async buyInPaymentGateway(packageData: any){
    this.load = true;
    this.startPaymentLoading.emit()
    if (!this.withoutPackage) {
      this.topupData = {
        ...this.selectedData,
        packageId: packageData._id,
        provider: 'paymentGateway',
        publisherId: this.publisherId,
        topic: this.selectedData.topic,
        metadata: this.selectedData.metadata,
      };
      let newAmount
      if(this.selectedData.topic === 'ticket'){
        newAmount = this.getAmount(this.selectedData.ticket);
      }else {
        newAmount = this.selectedData.amount
      }

      this.selectedData.description = newAmount.toFixed(2) + ' ' + this.selectedData.currency;
    } else {
      this.topupData = {
        ...this.selectedData,
        serviceId: packageData._id,
        provider: 'paymentGateway',
        topic: this.selectedData.topic,
        serviceCount: this.selectedData.serviceCount,
        requiredFields: packageData.requiredFields,
        email: packageData.email,
        metadata: packageData.metadata,
        currency: packageData.currency,
        productServices: packageData.productServices,
        tip: packageData.tip,
        productType: packageData.productType,
        donationInfo: this.selectedData.donationInfo
      };
      let newAmount
      if(this.selectedData.topic === 'ticket'){
        newAmount =  (this.selectedData.amount * this.ticketPrice + (200 / 10 * this.ticketPrice))
      }else {
        newAmount = this.selectedData.amount
      }
      this.selectedData.description = newAmount.toFixed(2)  + ' ' + this.selectedData.currency;
    }
    this.sendPayment(null)
  }

  paymentHandler: any = null;

  makePayment() {
    if (!(<any>window).StripeCheckout) {
      console.error('StripeCheckout is not loaded. Make sure the Stripe library is included.');
      return;
    }
    const paymentHandler = (<any>window).StripeCheckout.configure({
      key: environment.stripeKeys.PUBLIC_KEY,
      locale: 'auto',
      token: (stripeToken: any) => {
        this.sendPayment(stripeToken.id);
      },
      // payment_intent: (paymentIntent: any) => {
      //   this.sendPaymentIntent(paymentIntent.id);
      // },
    });

    paymentHandler.open({
      name: 'Cybfed',
      description: this.selectedData.description,
      email: this.withoutUser? this.selectedData.email: this.user.email,
    });
  }

  getAmount(priceArray: any) {
    let currency = this.user.currency;
    let index = priceArray.map(function(e: any) {
      return e.currency;
    }).indexOf(currency);
    let amount;
    if (!index) {
      amount = priceArray[0].amount;
    } else {
      amount = priceArray[index].amount;
    }
    amount += 200 / 10 * this.ticketPrice;

    return amount;
  }

  invokeStripe() {
    if (this.dom.getElementById('stripe-script')) {
      const script = this.dom.createElement('script');
      script.id = 'stripe-script';
      script.type = 'text/javascript';
      script.src = 'https://checkout.stripe.com/checkout.js';
      script.onload = () => {
        this.paymentHandler = (<any>window).StripeCheckout.configure({
          key: environment.stripeKeys.PUBLIC_KEY,
          locale: 'auto',
          token: function(stripeToken: any) {
            alert('Payment has been successfull!');
          },
        });
      };

      this.dom.body.appendChild(script);
    }
  }

  sendPayment(paymentId: any) {
      this.topupData.tokenId = paymentId;
      this.topupService.add(this.topupData).subscribe((data: any) => {
        if (!data.hasError) {
          if(this.topupData.provider === 'paymentGateway'){
            let url  = environment.paymentGatewayFrontUrl + '/' + data.data.topup.paymentCode;
            window.location.href = url;

            this.endPaymentLoading.emit();
          }else {
            this.popupHelperService.printSuccess();
            if(this.stripeModal){
              this.stripeModal.hide();
            }
            this.finishPayment.emit(data.data.topup)

            this.cardElement = undefined;
          }

          this.load = false;
        } else {
          this.popupHelperService.printError({ text: data.errorMessages[0].msg });
        }
        this.load = false;
        this.endPaymentLoading.emit()
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['show']) {
      if (this.show) {
        this.openPaymentModal();
      }
    }
  }

  hide() {

  }

  hideModal() {
    this.show = false;
    this.hideModalCallback.emit();
  }

  selectPaymentMethod(method: string) {
    this.selectedPayment = method
    this.changePaymentMethode.emit(method)
  }
  ngOnDestroy(): void {
    for (let sub of this.eventSubscriptions) {
      sub.unsubscribe();
    }
  }
}
